import { Component, inject, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PrepareAppointmentComponent } from '../prepare-appointment/prepare-appointment.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ID_LOGIN_TYPE, LINE_URL } from '../../shared/constants/common.constants';
import { MatButton } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
// 引入其他 component
import { TextComponent } from '../../shared/components/text/text.component';
import { TagComponent } from '../../shared/components/tag/tag.component';
import { MyReservationService } from '../../shared/services/my-reservation.service';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { AuthService } from '../../shared/services/auth.service';
import { DevService } from '../../shared/services/dev.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TwDatePipe } from '../../pipes/tw-date.pipe';
import { FormatDateMMDDPipe } from '../../pipes/format-date-mmdd.pipe';
import { BookingInfo, HealthCheckPlanResponse, ImageBookData, PostponeList, QuestionnaireStatusList } from '../../shared/interfaces/my-reservation.model';
import { STORAGE_KEY } from '../../shared/constants/store-key.constants';
import { MonthPipe } from '../../pipes/month.pipe';
import { DayPipe } from '../../pipes/day.pipe';
import { WeekdayPipe } from '../../pipes/weekday.pipe';
import { TimePeriodPipe } from '../../pipes/time.pipe';
import { BusinessPackageInfo, BusinessPlanRequest, PackageDetail } from '../../shared/interfaces/reserve-loading.model';
import { calculateAge } from '../../shared/utils/validator.util';
import { BookDatetimeInfo } from '../../shared/interfaces/appointment-info.model';
import { API_PARAMS } from '../../shared/constants/api.constants';
import { CITIES } from '../../shared/constants/location.constants';
import { NewMemberCenterNoDataComponent } from "./new-memberCenter-no-data/new-memberCenter-no-data.component";
import { BreakpointObserver } from '@angular/cdk/layout';
import { FormsService } from '../forms/forms.service';

import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';

interface GroupedPostpone {
  bookDate: string;
  items: Omit<PostponeList, 'bookDate'>[];
}

interface GroupedImageBook {
  bookDate: string;
  items: Omit<ImageBookData, 'imageBookDate'>[];
}


@Component({
  selector: 'app-new-member-center',
  standalone: true,
  imports: [
    MatTabsModule,
    PrepareAppointmentComponent,
    TranslatePipe,
    MatButton,
    NgOptimizedImage,
    TextComponent,
    TagComponent,
    FormatDateMMDDPipe,
    MonthPipe,
    DayPipe,
    WeekdayPipe,
    TimePeriodPipe,
    NewMemberCenterNoDataComponent,
    MatProgressBarModule
  ],
  templateUrl: './new-memberCenter.component.html',
  styleUrl: './new-memberCenter.component.scss'
})
export class NewMemberCenterComponent implements OnInit {
  selectedTab: number = 0; // 預設顯示第一個 tab
  groupedArray: GroupedPostpone[] = []; // 待補檢項目（依日期分組）
  groupedImageBooks: GroupedImageBook[] = []; // 高階影像（依日期分組）

  /** 單筆高階影像時取得第一筆 item（null 代表無資料） */
  get singleImageBookItem(): Omit<ImageBookData, 'imageBookDate'> | null {
    return this.groupedImageBooks[0]?.items[0] ?? null;
  }
  myReservationService: MyReservationService = inject(MyReservationService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  translateService: TranslateService = inject(TranslateService);
  breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
  authService: AuthService = inject(AuthService);
  devService: DevService = inject(DevService);
  dialog: MatDialog = inject(MatDialog);
  router: Router = inject(Router);
  formsService: FormsService = inject(FormsService);
  toastr: ToastrService = inject(ToastrService);
  twDatePipe: TwDatePipe = new TwDatePipe();

  protected readonly Number = Number;

  isMobile = false;//是否為手機版
  flowCode: string = ''; // 預約執行流程代號
  diffDays: number = 0; // 目前時間與預約時間相差天數
  bookDate: string = '';//健檢日期
  idNo: string = ''; // 身分證字號
  chartNo: string = ''; // 病歷號
  healthCheckPlan?: HealthCheckPlanResponse; // 健檢方案
  isLoading: boolean = true;// 載入狀態
  isShowReservation: boolean = false;// 是否顯示預約紀錄
  isShowNutrition: boolean = false;// 是否顯示營養諮詢
  isShowPostponeList: boolean = false;// 是否顯示待補檢項目
  isShowImageBookList: boolean = false;// 是否顯示高階影像預約列表
  imageExamCount: number = 0;// 高階影像預約數量
  isImageBookDateHasNull: boolean = false;// 是否顯示高階影像預約時間(當列表內無時間時，則不顯示預約時間區塊 )
  isShowModifyTime: boolean = true;  // 是否顯示修改鈕-健檢時間
  isShowQuestionnaire: boolean = true;   // 是否顯示問卷區塊

  isCompleted: boolean = false;  // 是否顯示完成
  isExpired: boolean = false;  // 是否顯示過期
  healthCheckCompleteStatus: boolean = false; // 健檢完成狀態
  sortedQuestionnaireStatusList: QuestionnaireStatusList[] = []; // 排序後的問卷狀態清單（questionnaireTypeId=3 優先，其餘依代碼升序）
  bookStatus: string = ''; // 預約狀態
  bookData: BookingInfo | null = null;
  serverTimestamp: string = ''; // 伺服器當下時間戳記
  contactZipCode: string = '';
  reportZipCode: string = '';
  packagePrice: number = 0; // 套檢金額
  billAmt: number = 0; // 總金額
  isProdEnvironment: boolean = false; // 是否為生產環境



  ngOnInit(): void {
    // 檢查環境配置，prod 環境2026/5/27不開放我的健檢檔案
    const env = (window as any)?.env;
    this.isProdEnvironment = env?.environment === 'prod';
    //檢查手機版或電腦版
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
    // 檢查 sharedStorage 中的 tab 設定
    const savedTab = this.sharedStorageService.get('memberCenterTab');
    if (savedTab !== undefined && savedTab !== null) {
      this.selectedTab = savedTab;
      // 讀取後立即清除，避免影響下次登入
      this.sharedStorageService.remove('memberCenterTab');
    }
    // 初始化
    // 取得登入信息(身分證字號、病例號)
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    this.idNo = createMemberRequest?.idNo ?? '';
    this.chartNo = createMemberRequest?.chartNo ?? '';

    // 取得預約紀錄及已完成健檢(CB-057)
    this.myReservationService
      .getAppointmentHistory(this.idNo)
      .subscribe({
        next: (res) => {
          this.flowCode = res.data?.flowCode ?? '';
          console.log('flowCode', this.flowCode);

          const myReservation = {
            flowCode: this.flowCode ?? '',
            bookStatus: '',
            diffDates: 0,
            bookDate: '',
            caseNo: '',
            companyNo: '',
            familyFlag: '',
            consentFormData: null,
            dataType: ''
          }
          this.sharedStorageService.set(STORAGE_KEY.MY_RESERVATION, myReservation);

          if (this.flowCode === '4') {
            // 2026.01.07取消個人150天內不可預約的限制(將不會有this.flowCode === '5')
            this.isShowReservation = true;

            // 已有預約資料(呼叫CB-007)，初始化預約資料
            this.myReservationService
              .getHealthCheckPlan(this.chartNo, this.idNo)
              .subscribe({
                next: (res) => {
                  console.log('取得健檢資料成功：', res);
                  this.healthCheckPlan = res.data;
                  console.log('healthCheckPlan', this.healthCheckPlan);
                  if (this.healthCheckPlan?.bookData == null) {
                    this.isShowReservation = false; // 不顯示
                    this.isLoading = false;
                    console.log("不顯示預約紀錄");
                    console.log('進入CB-007後this.isLoading:', this.isLoading);
                    return;
                  } else {
                    this.isShowReservation = true; // 顯示
                    console.log("顯示預約紀錄");
                  }

                  // 取得套檢金額與總金額
                  this.packagePrice = Number(this.healthCheckPlan?.packageGroup?.packagePrice ?? '');
                  this.billAmt = Number(this.healthCheckPlan?.packageGroup?.billAmt ?? '');

                  // 將預約資料存入 sharedStorage，供其他頁面使用
                  this.bookStatus = this.healthCheckPlan?.bookStatus ?? '';
                  this.bookDate = this.healthCheckPlan?.bookData.bookDate ?? '';
                  this.serverTimestamp = res.timestamp;
                  this.diffDays = this.calculateDiffDays(this.bookDate, res.timestamp);
                  console.log(`預約日期: ${this.bookDate}, 伺服器當下時間: ${res.timestamp}, 相差天數: ${this.diffDays}`);
                  //2026.05.25 bug 1386 本次預約_健檢日超過30日有顯示健檢資訊
                  if (this.diffDays < -30) {
                    this.isShowReservation = false; // 預約日期超過30天，隱藏預約紀錄
                  }
                  // 時間資訊卡(綠):依時間及預約狀態卡控
                  if (this.bookStatus === '3' || this.bookStatus === '8' || this.bookStatus === '9') {
                    this.isCompleted = true; //  顯示完成
                  } else if (this.bookStatus === '1' && this.diffDays < 0) {
                    this.isExpired = true; // 顯示過期
                  }
                  // 問卷區:2026.4.28 健檢當天 未報到才顯示，已報到則不顯示;健檢日過後，無論未報到已報到皆不再顯示。
                  if (this.diffDays === 0 && this.bookStatus !== '1') {
                    this.isShowQuestionnaire = false; // 健檢當天已報到 → 不顯示
                  } else if (this.diffDays < 0) {
                    this.isShowQuestionnaire = false; // 不顯示
                  }

                  // 是否顯示修改鈕、7天標籤
                  if (this.bookStatus === '8' || this.bookStatus === '9') {
                    // 報告已列印 / 已寄發 → 全部關閉
                    this.isShowModifyTime = false;

                  } else if (this.bookStatus === '1' && this.diffDays >= -30 && this.diffDays <0) {
                    // 未報到，健檢後 30 天內 → 可修改時間
                    this.isShowModifyTime = true;

                  } else if (this.diffDays <= 7) {
                    // 健檢 7 天內（含當天及健檢後）
                    this.isShowModifyTime = false;
                  }else if(this.diffDays<=10){
                    this.isShowModifyTime = false;
                  }

                  const myReservation = {
                    flowCode: this.flowCode ?? '',
                    bookStatus: this.healthCheckPlan?.bookStatus ?? '',
                    diffDates: this.diffDays ?? '',
                    bookDate: this.healthCheckPlan?.bookData.bookDate ?? '',
                    caseNo: this.healthCheckPlan?.bookData.caseNo ?? '',
                    companyNo: this.healthCheckPlan?.bookData.companyNo ?? '',
                    familyFlag: this.healthCheckPlan?.bookData.familyFlag ?? '',
                    consentFormData: this.healthCheckPlan?.consentFormData ?? null,
                    dataType: this.healthCheckPlan?.dataType ?? '' // 1：個人健檢 2：企業健檢
                  }
                  console.log('myReservation:', myReservation);
                  this.sharedStorageService.set(STORAGE_KEY.MY_RESERVATION, myReservation);

                  // 健檢資料
                  this.bookData = this.healthCheckPlan?.bookData ?? null;

                  //待補檢項目
                  const postponeList = this.healthCheckPlan?.postponeList ?? [];
                  if (postponeList && postponeList.length > 0) {
                    this.isShowPostponeList = true; // 顯示
                    this.getPostponeList();
                  } else {
                    this.isShowPostponeList = false; // 不顯示
                  }

                  //高階影像
                  const imageBookDataList = this.healthCheckPlan?.bookData.imageBookDataList ?? [];
                  // 模擬資料如下:
                  // const imageBookDataList: ImageBookData[] = [
                  //   {
                  //     imageExamItem: 'R123456789',
                  //     imageExamName: '低劑量肺部電腦斷層',
                  //     imageBookDate: '20250716',
                  //     imageBookTime: '1400提早10分鐘',
                  //     imageBookHospital: 'AA綜合醫院'
                  //   },
                  //   {
                  //     imageExamItem: 'A123456789',
                  //     imageExamName: '頸部磁振造影',
                  //     imageBookDate: '20250717',
                  //     imageBookTime: '1400',
                  //     imageBookHospital: 'QQ綜合醫院'
                  //   },
                  //   {
                  //     imageExamItem: 'Q123456789',
                  //     imageExamName: '腰薦椎磁振造影',
                  //     imageBookDate: '20250717',
                  //     imageBookTime: '',
                  //     imageBookHospital: 'oo綜合醫院'
                  //   }
                  //   ,
                  //   {
                  //     imageExamItem: 'A123456789',
                  //     imageExamName: '上腹部核磁共振',
                  //     imageBookDate: '',
                  //     imageBookTime: '',
                  //     imageBookHospital: 'oo綜合醫院'
                  //   }
                  // ];
                  if (imageBookDataList && imageBookDataList.length > 0) {
                    this.imageExamCount = imageBookDataList.length;
                    this.isShowImageBookList = true; // 顯示
                    this.getImageBookDataList();
                  } else {
                    this.isShowImageBookList = false; // 不顯示
                  }


                  // 同意書
                  this.sortQuestionnaireStatusList();


                },
                error: (err) => {
                  //  API 404, 500 或網路斷線
                  console.error('取得資料時發生錯誤：', err);
                  this.isShowReservation = false;
                },
                complete: () => {
                  this.isLoading = false; // 關閉載入中
                }
              });




          } else {
            // 沒有預約資料
            this.isShowReservation = false; // 不顯示
            this.isLoading = false; // 關閉載入中
          }

        },
        error: (err) => {
          //  API 404, 500 或網路斷線
          console.error('取得資料時發生錯誤：', err);
          this.isShowReservation = false;
          this.isLoading = false; // 關閉載入中
        }
      })
  }


  // 導轉各問卷頁面--------------
  goQuestionnaire(questionnaireTypeId: string): void {
    this.sharedStorageService.set('currentRoute', this.router.url);
    this.router.navigate(['healthcheck/member/mybooking/forms', questionnaireTypeId]).then();
  }

  // 前往導航
  goNavigation(): void {
    const orgUrl = this.healthCheckPlan?.bookData?.orgUrl;
    if (orgUrl) {
      window.open(orgUrl, '_blank');
    }
  }

  // 前往我的健檢檔案
  goMyprofile(): void {
    this.router.navigate(['/healthcheck/member/myprofile']).then();
  }

  // 導向預約時間頁面
  modifyTime() {

    // 檢驗金額dialog - 待規格出來再打開 (若總金額 < 套檢金額)
    if (this.billAmt < this.packagePrice) {
      const priceDialog = this.dialog.open(SingleActionDialogComponent, {
        data: {
          title: this.translateService.instant('my-reservation.price-dialog'),
          message: this.translateService.instant('my-reservation.price-dialog-message'),
          buttonText: this.translateService.instant('common.button.i-understood'),
          showCloseButton: false,
          action: () => priceDialog.close(),
        },
      });
      return;
    }

    this.sharedStorageService.set('reserveStep', 7);
    this.sharedStorageService.set('selectedPackage', this.healthCheckPlan?.packageGroup.packageName ?? '');
    const paymentAmount = this.healthCheckPlan?.packageGroup.billAmt ?? '0';
    this.sharedStorageService.set('packagePrice', paymentAmount);
    this.setSharedStorage();//提供後續打API的request資料
    this.sharedStorageService.set('modifyType', "modifyTime");// 已預約後的修改項目，"time":改時間，"modifyExam":調整檢項
    this.router.navigate(['/healthcheck/reserve/timeselect']).then();
  }
  setSharedStorage() {
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    // 提供給會員中心[健康調查表]
    const myReservation = {
      flowCode: this.flowCode ?? '',
      bookStatus: this.healthCheckPlan?.bookStatus ?? '',
      diffDates: this.diffDays ?? '',
      bookDate: this.healthCheckPlan?.bookData.bookDate ?? '',
      caseNo: this.healthCheckPlan?.bookData.caseNo ?? '',
      companyNo: this.healthCheckPlan?.bookData.companyNo ?? '',
      familyFlag: this.healthCheckPlan?.bookData.familyFlag ?? '',
      consentFormData: this.healthCheckPlan?.consentFormData ?? null,
      dataType: this.healthCheckPlan?.dataType ?? '' // 1：個人健檢 2：企業健檢
    }
    this.sharedStorageService.set(STORAGE_KEY.MY_RESERVATION, myReservation);

    const contactAddress = this.parseAddress(this.healthCheckPlan?.bookData.contactAddress ?? '');
    const deliveryAddress = this.parseAddress(this.healthCheckPlan?.bookData.deliveryAddress ?? '');
    // bookingInfo->如果appointment-time初始化不是從這裡取得的話bookingInfo可以整個不要
    const bookingInfo = {
      checkupDate: {
        bookDate: this.healthCheckPlan?.bookData.bookDate ?? '',
        bookTime: this.healthCheckPlan?.bookData.bookTime ?? '',
      } as BookDatetimeInfo,
      nutrition: {
        bookDate: this.healthCheckPlan?.bookData.nutBookDate ?? '',
        bookTime: this.healthCheckPlan?.bookData.nutBookTime ?? '',
      } as BookDatetimeInfo,
      imagingContact: '',
      orgNo: this.healthCheckPlan?.bookData.orgNo ?? '',
      preExamInfoDeliveryMethod: this.healthCheckPlan?.dataType === '1'//個人
        ? API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.INDIVIDUAL.code
        : API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.AGENT.code,
      deliveryMethod: this.healthCheckPlan?.bookData.deliveryType ?? '',//檢查報告領取方式0：郵寄國內 ⇒ 一般(聯絡地址)（僅個人）9：郵寄國外 ⇒ 國際航空(郵資自付)（僅個人）2：承辦領取（僅企業）3：不須寄送（僅企業）
      city: contactAddress?.cityName ?? '',
      district: contactAddress?.areaName ?? '',
      zipCode: this.healthCheckPlan?.bookData.contactZipCode ?? contactAddress?.zipCode ?? '',
      address: contactAddress?.address,
      reportCity: deliveryAddress?.cityName ?? '',
      reportDistrict: deliveryAddress?.areaName ?? '',
      reportZipCode: deliveryAddress?.zipCode ?? '',
      reportAddress: deliveryAddress?.address ?? '',
      foreignAddress: this.healthCheckPlan?.bookData.deliveryType === '9' ? this.healthCheckPlan?.bookData.deliveryAddress ?? '' : '',
      deliveryRecipient: this.healthCheckPlan?.bookData.recipient === createMemberRequest?.name ? '01' : '02',
      recipient: this.healthCheckPlan?.bookData.recipient ?? '',
      recipientCell: this.healthCheckPlan?.bookData.recipientCell ?? '',
      email: '',
      language: this.healthCheckPlan?.bookData.language.uno ?? '',
      clothesSize: this.healthCheckPlan?.bookData.clothesSize.uno ?? '',
      breakfast: this.healthCheckPlan?.bookData.breakfast.uno ?? '',
      lunch: this.healthCheckPlan?.bookData.lunch.uno ?? '',
      dayType: '',
    };
    this.contactZipCode = this.healthCheckPlan?.bookData.contactZipCode ?? contactAddress?.zipCode ?? '';
    this.reportZipCode = deliveryAddress?.zipCode ?? '';
    this.sharedStorageService.set(STORAGE_KEY.BOOKING_INFO, bookingInfo ?? []);

    // userPlanRequest
    const userPlanRequest = {
      orgNo: this.healthCheckPlan?.bookData.orgNo ?? '',
      gender: createMemberRequest?.gender ?? '',
      birthday: createMemberRequest?.birthday ?? '',
      age: calculateAge(createMemberRequest?.birthday ?? '').toString(),
      idNo: createMemberRequest?.idNo ?? '',
      identityType: '0',//'0'為有身分證，'1'為UUID
      name: createMemberRequest?.name ?? '',
      cell: '',
      email: '',
      telH: '',
      telO: '',
      zipCode: '',
      history: [],
      family: [],
      subjectiveSymptoms: [],
    };
    this.sharedStorageService.set(STORAGE_KEY.USER_PLAN_REQUEST, userPlanRequest ?? []);

    // examItemList
    const examItemList = this.healthCheckPlan?.packageGroup.packageInfo.planList.flatMap(planItem =>
      planItem.examItemList.map(exam => ({
        deptName: planItem.deptName,
        deptEName: planItem.deptEName,
        examName: exam.examName,
        examItem: exam.examItem,
        examPrice: exam.examPrice,
        examMemo: exam.examMemo ?? '',
        selectFlag: 1,
      }))
    );
    this.sharedStorageService.set(STORAGE_KEY.EXAM_ITEM_LIST, examItemList ?? []);

    // addExamItemList
    const addExamItemList = this.healthCheckPlan?.packageGroup.packageInfo.addList.map(exam => ({
      examName: exam.examName,
      examItem: exam.examItem,
      examMemo: exam.examMemo ?? '',
      price: exam.examPrice,
      mutexInfos: [],
      isNecessary: false,
      isChoice: true,
      disable: false,
      examType: '',
      deptName: '',
      deptEName: '',
    }));
    this.sharedStorageService.set(STORAGE_KEY.ADD_EXAM_ITEM_LIST, addExamItemList ?? []);

    if (!this.isPersonal) {
      //企業
      // 判斷健檢時段：根據 bookTime 判斷上午(1)或下午(2)
      const bookTime = this.healthCheckPlan?.bookData.bookTime ?? '';
      const bookPeriod = Number(bookTime) < 1200 ? '1' : '2';

      // 判斷是否有早餐和午餐
      const hasBreakfast = !!(this.healthCheckPlan?.bookData.breakfast?.uno);
      const hasLunch = !!(this.healthCheckPlan?.bookData.lunch?.uno);

      // 轉換 planList 為 BusinessPackageInfo 格式
      const deptList: Array<BusinessPackageInfo> = this.healthCheckPlan?.packageGroup.packageInfo.planList.map(planItem => ({
        deptName: planItem.deptName,
        deptEName: planItem.deptEName,
        examItemList: planItem.examItemList.map(exam => ({
          examItem: exam.examItem,
          examName: exam.examName,
          examMemo: exam.examMemo ?? ''
        }))
      })) ?? [];

      let businessPrice = Number(this.healthCheckPlan?.packageGroup.billAmt) ?? 0;
      const addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
      const addExamPrice = addExamItemList.reduce((total, item) => {
        return total + (Number(item.price) || 0);
      }, 0);
      businessPrice = businessPrice - addExamPrice;

      const businessSelectedPackage: PackageDetail = {
        packageNo: this.healthCheckPlan?.packageGroup.packageNo ?? '',
        packageName: this.healthCheckPlan?.packageGroup.packageName ?? '',
        price: businessPrice.toString() ?? '',
        dayType: this.healthCheckPlan?.packageGroup.dayType ?? '',
        bookPeriod: bookPeriod,
        hasBreakfast: hasBreakfast,
        hasLunch: hasLunch,
        deptList: deptList,
        examChooseList: [],
        groupChooseList: [],
      }
      this.sharedStorageService.set('businessSelectedPackage', businessSelectedPackage);

      const businessPlanRequest: BusinessPlanRequest = {
        orgNo: this.healthCheckPlan?.bookData.orgNo ?? '',
        companyNo: this.healthCheckPlan?.bookData.companyNo ?? '',
        gender: createMemberRequest?.gender ?? '',
      };
      this.sharedStorageService.set('businessPlanRequest', businessPlanRequest);
    }

  }

  // 是否為個人健檢
  get isPersonal(): boolean {
    console.log('this.healthCheckPlan?.dataType:', this.healthCheckPlan?.dataType);
    if (this.healthCheckPlan?.dataType === '1') {
      console.log('是個人健檢');
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);
      return true;
    } else {
      console.log('是企業健檢');
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.ENTERPRISE);
      return false;
    }
  }
  // 已完成問卷數量（status !== '1'）
  completedCount(): number {
    // 模擬資料
    // this.sortedQuestionnaireStatusList = [
    //             {
    //                 "questionnaireTypeId": "3",
    //                 "questionnaireName": "健康調查表",
    //                 "status": "1"
    //             },
    //             {
    //                 "questionnaireTypeId": "1",
    //                 "questionnaireName": "異常工作負荷檢核表",
    //                 "status": "3"
    //             },
    //             {
    //                 "questionnaireTypeId": "2",
    //                 "questionnaireName": "肌肉骨骼症狀調查表",
    //                 "status": "2"
    //             },

    //         ]
    return this.sortedQuestionnaireStatusList.filter(item => item.status !== '1' && item.status !== '4').length;
  }

  // 問卷完成百分比（用於進度條）
  percentValue(): number {
    const total = this.sortedQuestionnaireStatusList.length;
    if (total === 0) return 0;
    return Math.round((this.completedCount() / total) * 100);
  }

  // 判斷健檢日期是否已過期(已報到)
  isBookDatePast(): boolean {
    if (!this.serverTimestamp || !this.bookData?.bookDate) return false;
    if (this.diffDays <= 0 && this.bookStatus !== '1') {
      return true;
    } else {
      return false;
    }
  }

  // 判斷指定日期（YYYYMMDD）是否早於伺服器時間
  isDatePast(bookDate: string): boolean {
    if (!this.serverTimestamp || !bookDate) return false;
    const now = new Date(this.serverTimestamp);
    const date = new Date(
      parseInt(bookDate.substring(0, 4)),
      parseInt(bookDate.substring(4, 6)) - 1,
      parseInt(bookDate.substring(6, 8))
    );
    return now > date;
  }
  //地址轉換
  parseAddress(address: string) {
    // '台'開頭的地址改為'臺'開頭，增加比對成功率
    address = address.trim();
    if (address.startsWith('台')) {
      address = '臺' + address.slice(1);
    }
    for (const city of CITIES) {
      if (address.startsWith(city.cityName)) {
        const rest = address.slice(city.cityName.length); // 去掉縣市
        for (const area of city.areaList) {
          if (rest.startsWith(area.areaName)) {
            const detailAddress = rest.slice(area.areaName.length); // 去掉行政區

            return {
              cityName: city.cityName,
              cityEngName: city.cityEngName,
              areaName: area.areaName,
              areaEngName: area.areaEngName,
              zipCode: area.zipCode,
              address: detailAddress, // 剩下的地址
            };
          }
        }
      }
    }
    return null; // 沒找到
  }
  //計算距離健檢日天數
  calculateDiffDays(bookDate: string, timestamp: string): number {
    const now = new Date(timestamp);
    let diffDays = 0;
    if (bookDate === undefined) {
      this.isShowReservation = false;
    } else {
      const year = parseInt(bookDate.substring(0, 4));
      const month = parseInt(bookDate.substring(4, 6)) - 1; // Months are 0-indexed
      const day = parseInt(bookDate.substring(6, 8));
      const book = new Date(year, month, day);

      const bookDateOnly = new Date(book.getFullYear(), book.getMonth(), book.getDate());
      const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const timeDiff = bookDateOnly.getTime() - nowDateOnly.getTime();
      diffDays = Math.round(timeDiff / (1000 * 60 * 60 * 24)); // 轉換為天數
    }

    return diffDays;
  }

  // 問卷狀態清單排序（questionnaireTypeId=3 優先，其餘依代號大小）--------------
  sortQuestionnaireStatusList(): void {
    console.log('問卷狀態清單', this.healthCheckPlan);
    const list = this.healthCheckPlan?.consentFormData?.questionnaireStatusList ?? [];
    console.log('原始問卷狀態清單:', list);
    // 個人資料告知事項暨同意書(questionnaireTypeId=5)已填過(status=2)即不納入清單
    const now = new Date();
    const todayStr = Number(now.getFullYear().toString() +
      (now.getMonth() + 1).toString().padStart(2, '0') +
      now.getDate().toString().padStart(2, '0'));// 今日日期（YYYYMMDD）
    const bookDate = Number(this.healthCheckPlan?.bookData.bookDate) ?? '';// 健檢日期（YYYYMMDD）
    const filteredList = list.filter(
      item => !(item.questionnaireTypeId === '5' && item.status === '2' && bookDate < todayStr)
    );
    this.sortedQuestionnaireStatusList = [...filteredList].sort((a, b) => {
      const idA = Number(a.questionnaireTypeId);
      const idB = Number(b.questionnaireTypeId);
      // questionnaireTypeId=3 排第一
      if (idA === 3 && idB !== 3) return -1;
      if (idB === 3 && idA !== 3) return 1;
      // 其餘依 questionnaireTypeId 大小排序
      return idA - idB;
    });
    console.log('排序後問卷狀態清單:', this.sortedQuestionnaireStatusList);
  }

  // 待補檢項目--------------
  getPostponeList() {
    const postponeList = this.healthCheckPlan?.postponeList ?? [];
    // 模擬資料如下:
    //   const postponeList: Array<PostponeList> = [
    //   {
    //     bookDate: '20220907',
    //     bookTime: '0830',
    //     examItem: 'P44546',
    //     examName: '婦科病史',
    //     remark: '補檢08:30-09:00報到'
    //   },
    //   {
    //     bookDate: '20220912',
    //     bookTime: '0930',
    //     examItem: 'L445646',
    //     examName: '尿沉渣鏡檢',
    //     remark: ''
    //   },
    //   {
    //     bookDate: '20220912',
    //     bookTime: '1030',
    //     examItem: 'L11213',
    //     examName: '抽血檢查',
    //     remark: ''
    //   }
    // ];

    if (postponeList.length === 0) {
      this.isShowPostponeList = false;
      console.log('已執行getPostponeList()，但沒有待補檢項目');
      return;
    }

    /**
     * 依 bookDate 分組
     */
    const groupedObject = postponeList.reduce(
      (groupedByDate, currentItem) => {
        const { bookDate, ...itemWithoutDate } = currentItem;

        // 如果該日期還沒初始化，先建立陣列
        if (!groupedByDate[bookDate]) {
          groupedByDate[bookDate] = [];
        }

        // 加入該日期底下
        groupedByDate[bookDate].push(itemWithoutDate);

        return groupedByDate;
      },
      {} as Record<string, Omit<PostponeList, 'bookDate'>[]>
    );

    /**
     * 轉成陣列（給 Angular template 用），賦值給類別屬性
     */
    this.groupedArray = Object.entries(groupedObject).map(
      ([bookDate, items]) => ({
        bookDate,
        items
      })
    );

    console.log('待補檢項目:', this.groupedArray);
  }

  // 高階影像--------------
  getImageBookDataList(): void {
    console.log('高階影像');
    // 模擬資料如下:
    // const imageBookDataList: ImageBookData[] = [
    //   {
    //     imageExamItem: 'R123456789',
    //     imageExamName: '低劑量肺部電腦斷層',
    //     imageBookDate: '20250716',
    //     imageBookTime: '1400提早10分鐘',
    //     imageBookHospital: 'AA綜合醫院'
    //   },
    //   {
    //     imageExamItem: 'A123456789',
    //     imageExamName: '頸部磁振造影',
    //     imageBookDate: '20250717',
    //     imageBookTime: '1400',
    //     imageBookHospital: 'QQ綜合醫院'
    //   },
    //   {
    //     imageExamItem: 'Q123456789',
    //     imageExamName: '腰薦椎磁振造影',
    //     imageBookDate: '20250717',
    //     imageBookTime: '',
    //     imageBookHospital: 'oo綜合醫院'
    //   },
    //   {
    //     imageExamItem: 'A123456789',
    //     imageExamName: '上腹部核磁共振',
    //     imageBookDate: '',
    //     imageBookTime: '',
    //     imageBookHospital: 'oo綜合醫院'
    //   }

    // ];
    const imageBookDataList = this.healthCheckPlan?.bookData.imageBookDataList ?? [];

    // 解析 imageBookTime 格式（在分組前）
    let isDateNullCount: number = 0;
    const parsedList = imageBookDataList.map(item => {

      // 日期空值的處理
      if (!item.imageBookDate) {
        console.log(item.imageExamName, '日期為空，將顯示預設文字');
        isDateNullCount++;
      }

      // 時間空值的處理
      if (!item.imageBookTime) {
        console.log(item.imageExamName, '時間為空');
        return {
          ...item,
          imageBookTime: ''
        };
      }

      // 時間非空值的處理
      const timeMatch = item.imageBookTime.match(/^(\d{4})(.*)$/);
      const timeOnly = timeMatch ? timeMatch[1] : '';
      const noteText = timeMatch ? timeMatch[2] : '';

      let timeDisplay: string;
      if (timeOnly) {
        // 時間有四位數字時，顯示上午/下午和格式化時間
        // imageBookTime: '1400提早10分鐘' -> '下午02:00提早10分鐘'
        // 1. 先提取小時與分鐘
        const hours = Math.floor(Number(timeOnly) / 100);
        const minutes = timeOnly.slice(-2);

        // 2. 判斷早午晚（維持你原本的邏輯）
        const periodText = Number(timeOnly) < 1200
          ? this.translateService.instant('my-reservation.morning')
          : this.translateService.instant('my-reservation.afternoon');

        // 3. 轉換為 12 小時制格式
        // 如果小時大於 12，則減去 12；如果等於 0，則設為 12 (午夜)
        const displayHours = hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours);

        // 4. 補零並組合 (例如把 2 變成 02)
        const formattedTime = `${displayHours.toString().padStart(2, '0')}:${minutes}`;

        timeDisplay = periodText + formattedTime + noteText;
      } else {
        // 沒有四位數字時，直接顯示原始文字
        timeDisplay = item.imageBookTime;
        console.log('無法解析時間，直接顯示原始文字:', timeDisplay);
      }

      return { ...item, imageBookTime: timeDisplay };
    });

    // 依日期分組
    const groupedByDate = parsedList.reduce((groups, currentItem) => {
      const { imageBookDate, ...itemWithoutDate } = currentItem;
      if (!groups[imageBookDate]) {
        groups[imageBookDate] = [];
      }
      groups[imageBookDate].push(itemWithoutDate);
      return groups;
    }, {} as Record<string, Omit<ImageBookData, 'imageBookDate'>[]>);

    // 轉成陣列給 template 使用，並排序日期與時間
    this.groupedImageBooks = Object.entries(groupedByDate)
      .map(([bookDate, items]) => ({
        bookDate,
        items: items.sort((a, b) => (a.imageBookTime ?? '').localeCompare(b.imageBookTime ?? ''))
      }))
      .sort((a, b) => a.bookDate.localeCompare(b.bookDate));


    if (isDateNullCount > 0) {
      console.log('有高階影像的日期為空值');
      this.isImageBookDateHasNull = true;
    }
    console.log('高階影像列表:', this.groupedImageBooks);
  }



  //導轉到LINE
  handleToLine(): void {
    window.open(LINE_URL, '_blank');
  }


}
